import React from "react";

import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children, token }) => {
  return token ? children : <Navigate to="/login" />;
};
